'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:GoogleApi
 * @description
 * # GoogleApi
 * GoogleApi is a service to connect with google auth and drive
 */
angular.module('thothApp.services')
.factory('GoogleApi', ['$auth', '$state', '$rootScope', '$window', 'domain', 'toaster',
'cfpLoadingBar', '$q', '$timeout',
function ($auth, $state, $rootScope, $window, domain, toaster, cfpLoadingBar, $q, $timeout) {

  $rootScope.isClientUpdate = false;

  // The Browser API key obtained from the Google Developers Console.
  const DEV_KEY = 'AIzaSyDX-JE-T7apmUGyxxAfZcJ6dloKQMYOj4U';
  // The Client ID obtained from the Google Developers Console. Replace with your own Client ID.
  const CLIENT_ID = '660778749367-vtphhn299drdv4ltj2qkt9hog774kdku.apps.googleusercontent.com';
  const BASE_AUTH_URL = domain.name + '/users/auth/google_oauth2/callback';
  // Scope to use to access user's photos.
  const USER_SCOPE = 'email profile https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/calendar';
  const GOOGLE_BASE_FOLDER_URL = "https://drive.google.com/drive/folders/";
  const BASE_CLIENT_PATH_KEY = '0B9J2dBrSlbrkSldCbmFydlJ2ZHc';
  const PRODUCT_CONTRACT_PATH_KEY = '10rAqk_RDBKu9RfVMChVeGjjGth6tbbT2dYJfucfldxk';

  var DOMAIN;
  if (domain.name.includes('localhost')) {
    DOMAIN = '.localhost';
  } else if (domain.name.includes('scisa.com.mx')) {
    DOMAIN = '.scisa.com.mx';
  }

  const NEW_CLIENT_FOLDER_STRUCT_refact = [
    {
      name: "Administración",
      childFolders: [
        "Documentos de Identificación del Cliente",
        "Cobranza",
        "Datos generales del cliente",
        "Contratos"
      ],
      copyAdmin: true
    },
    {
      name: "Comercial",
      childFolders: [
        "Propuesta de servicio",
        "Propuestas adicionales",
        "Informacion del negocio del cliente"
      ]
    },
    {
      name: "Proyectos"
    },
    {
      name: "Soporte Técnico"
    }
  ];

  const NEW_PROSPECT_FOLDER_STRUCT_refact = [
    {
      name: "Administración",
      childFolders: [
        "Datos generales del prospecto",
        "NDA"
      ]
    },
    {
      name: "Comercial",
      childFolders: [
        "Propuesta de servicio",
        "Borradores de contrato",
        "Informacion del negocio del cliente"
      ]
    }
  ];

  const NEW_QUOTATION_FOLDER_STRUCT = [
    {
      name: '_Pricing SigloCDyPLD v3.0',
      pathKey: '1Fn6c0XvMECs_qgcmREisyDWj95vJc2uKK9LXCfWLapU'
    },
    {
      name: '_Cotizacion/Prospecto',
      pathKey: '1OzZW_zLuHVuqm87QfIqCtBPBLtSkAJAJIRsOhnkB7yk'
    }
  ];

  var pickerApiLoaded = false;

  const folders = [
    'Requerimiento',
    'Análisis',
    'Propuesta',
    'VoBo Cliente',
    'Plan de Trabajo'
  ];

  const LEGACY_FOLDERS = [
    'Requerimientos',
    'Pre Análisis',
    'Propuesta',
    'Autorización del Cliente y OC',
    'Plan de Trabajo',
    'Análisis',
    'Desarrollo y Pruebas',
    'Validación del Cliente',
    'Cierre'
  ];

  const folderLabel = function(name) {
    return String(name)
      .replace(/^\s*\d+\s*\.\s*/, '')
      .replace(/^.*?\d{3,}_/, '')
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .toLowerCase()
      .trim();
  };

  const countMatches = function(folderNames, structure) {
    const labels = folderNames.map(folderLabel);
    return structure.filter(function(folder) {
      return labels.indexOf(folderLabel(folder)) !== -1;
    }).length;
  };

  const structureFor = function(folderNames) {
    const found = folderNames || [];
    return countMatches(found, LEGACY_FOLDERS) > countMatches(found, folders) ? LEGACY_FOLDERS : folders;
  };

  // Cada variable se nombra completa porque webpack solo reemplaza asi el valor
  // del archivo .env. Fuera de webpack, process no existe y queda vacia.
  const configValue = function(read) {
    try {
      return read() || '';
    } catch (error) {
      return '';
    }
  };

  const PROJECT_TEMPLATES = [
    {
      document: 'Plan de trabajo',
      folder: 'Plan de Trabajo',
      readId: function() { return process.env.TEMPLATE_PLAN_TRABAJO_ID; }
    },
    {
      document: 'Detalle de alcance',
      folder: 'Análisis',
      readId: function() { return process.env.TEMPLATE_DETALLE_ALCANCE_ID; }
    },
    {
      document: 'Requerimiento del cliente',
      folder: 'Requerimiento',
      readId: function() { return process.env.TEMPLATE_REQUERIMIENTO_CLIENTE_ID; }
    }
  ];

  const projectNameFrom = function(folderName, project_code) {
    return String(folderName || '').replace(project_code + '_', '').trim();
  };

  const templateDocumentName = function(templateName, project_code, projectName) {
    const code = String(project_code || '').trim();
    const project = String(projectName || '').trim();

    var name = String(templateName || '')
      .replace(/^\s*plantilla\s*_?\s*/i, '')
      .replace(/SCISA[_ ]?0?X{4,5}/i, code)
      .replace(/SCISA[_ ]?00000/i, code)
      .replace(/Nombre[_ ]?Del[_ ]?Proyecto|Nombre[_ ]?del[_ ]?proyecto|NombreProyecto/i, project)
      .replace(/_{2,}/g, '_')
      .trim();

    if (code && name.indexOf(code) === -1) {
      name = code + '_' + name;
    }
    if (project && name.indexOf(project) === -1) {
      const extension = (name.match(/\.[A-Za-z0-9]{2,5}$/) || [''])[0];
      name = name.slice(0, name.length - extension.length) + '_' + project + extension;
    }
    return name;
  };

  var client;
  var access_token;

  // A simple callback implementation.
  function pickerFolderCallback(data) {
    if(data.action === 'picked') {
      $rootScope.rootPath = data.docs[0];
      $rootScope.isPicked = true;
      $rootScope.$apply();
      if($rootScope.isQuotation) {
        $rootScope.changeState($rootScope.event);
      }
      $rootScope.isQuotation = false;
      $rootScope.isPicked = true;
    }
  }

  // Callback implementation for forms.
  function pickerFormCallback(data) {
    if(data.action === 'picked') {
      $rootScope.rootForm = data.docs[0];
      $rootScope.$apply();
    }
  }

  // Callback implementation for files.
  function pickerFileCallback(data) {
    if(data.action === 'picked') {
      $rootScope.rootFile = data.docs[0];
      $rootScope.$apply();
    }
  }

  function createFolderPicker(parentId) {
    parentId = parentId || 'root';
    if (pickerApiLoaded && $window.localStorage.googleToken) {
      var view = new google.picker.DocsView(google.picker.ViewId.FOLDERS);
      view.setParent(parentId);
      view.setSelectFolderEnabled(true);
      var picker = new google.picker.PickerBuilder().
        addView(view).
        setOAuthToken($window.localStorage.googleToken).
        setSelectableMimeTypes('application/vnd.google-apps.folder').
        setDeveloperKey(DEV_KEY).
        setCallback(pickerFolderCallback).
        build();
      picker.setVisible(true);
    }
  }

  function createFormPicker(parentId) {
    parentId = parentId || 'root';
    if (pickerApiLoaded && $window.localStorage.googleToken) {
      var view = new google.picker.DocsView(google.picker.ViewId.FORMS);
      view.setParent(parentId);
      view.setIncludeFolders(true);
      var picker = new google.picker.PickerBuilder().
        addView(view).
        setOAuthToken($window.localStorage.googleToken).
        setSelectableMimeTypes('application/vnd.google-apps.form').
        setDeveloperKey(DEV_KEY).
        setCallback(pickerFormCallback).
        build();
      picker.setVisible(true);
    }
  }

  function createFilePicker(parentId) {
    parentId = parentId || 'root';
    if (pickerApiLoaded && $window.localStorage.googleToken) {
      var view = new google.picker.DocsView(google.picker.ViewId.PDFS);
      view.setParent(parentId);
      view.setIncludeFolders(true);
      var picker = new google.picker.PickerBuilder().
        addView(view).
        setOAuthToken($window.localStorage.googleToken).
        // setSelectableMimeTypes('application/vnd.google-apps.unknown').
        setDeveloperKey(DEV_KEY).
        setCallback(pickerFileCallback).
        build();
      picker.setVisible(true);
    }
  }

  function createFolder(data) {
    return $window.gapi.client.request({
      'path': 'https://www.googleapis.com/drive/v3/files/',
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      },
      'body': data
    });
  }

  function createEvent(data) {
    data.sendUpdates = 'all';
    return $window.gapi.client.request({
      'path': 'https://www.googleapis.com/calendar/v3/calendars/primary/events',
      'method': 'POST',
      'params': {
        'sendUpdates': 'all',
        'supportsAttachments': true
      },
      'headers': {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      },
      'body': data
    });
  }

  function updateFolderName(folderId, folderName) {
    var data = {
      name: folderName,
      mimeType: 'application/vnd.google-apps.folder'
    };
    return $window.gapi.client.request({
      'path': 'https://www.googleapis.com/drive/v3/files/' + folderId,
      'method': 'PATCH',
      'headers': {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      },
      'body': data
    });
  }

  function copyFile(fileId, data) {
    return $window.gapi.client.request({
      path: 'https://www.googleapis.com/drive/v3/files/' + fileId + '/copy',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      },
      body: data
    });
  }

  function deleteFolder(folderId) {
    return $window.gapi.client.request({
      path: 'https://www.googleapis.com/drive/v3/files/' + folderId,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      }
    });
  }

  function findFolder(folderId) {
    return $window.gapi.client.request({
      path: 'https://www.googleapis.com/drive/v3/files/',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      },
      params: {
        'orderBy': 'name',
        'q': 'parents in \"' + folderId + '\" and mimeType = \"' + 'application/vnd.google-apps.folder' + '\" and trashed = false',
      }
    });
  }

  function findParentFolder(folderId) {
    return $window.gapi.client.request({
      'path': `https://www.googleapis.com/drive/v3/files/${folderId}?fields=parents`,
      'method': 'GET',
      'headers': {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      }
    });
  }

  function findFile(folderId) {
    return $window.gapi.client.request({
      path: 'https://www.googleapis.com/drive/v3/files/',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      },
      params: {
        'orderBy': 'name',
        'q': 'parents in \"' + folderId + '\" and mimeType != \"' + 'application/vnd.google-apps.folder' + '\" and trashed = false',
      }
    });
  }

  //Recursive function that applies backoff algorithm to create folder in google drive api
  function createFolderBackOff(data, timeoutExponent) {
    var deferred = $q.defer();
    timeoutExponent = timeoutExponent || 1;
    $timeout(() => {
      createFolder(data).then((response) => {
        deferred.resolve(response);
      }).catch((error) => {
        if(error.status === 403 && timeoutExponent < 5) {
          return createFolderBackOff(data, timeoutExponent + 1);
        } else {
          return deferred.reject(error);
        }
      });
    }, Math.pow(10, timeoutExponent));

    return deferred.promise;
  }

  //Recursive function that applies backoff algorithm to copy file in google drive api
  function copyFileBackOff(sourceId, data, timeoutExponent) {
    var deferred = $q.defer();
    $timeout(() => {
      copyFile(sourceId, data).then((response) => {
        deferred.resolve(response);
      }).catch((error) => {
        if(error.status === 403 && timeoutExponent < 5) {
          return copyFileBackOff(sourceId, data, timeoutExponent + 1);
        } else {
          return deferred.reject(error);
        }
      });
    }, Math.pow(10, timeoutExponent));

    return deferred.promise;
  }

  //Recursive function that applies backoff algorithm to find folders in google drive api
  function findFolderBackOff(parentId, timeoutExponent) {
    var deferred = $q.defer();
    $timeout(() => {
      findFolder(parentId).then((response) => {
        deferred.resolve(response);
      }).catch((error) => {
        if(error.status === 403 && timeoutExponent < 5) {
          return findFolderBackOff(parentId, timeoutExponent + 1);
        } else {
          return deferred.reject(error);
        }
      });
    }, Math.pow(10, timeoutExponent));

    return deferred.promise;
  }

  //Recursive function that applies backoff algorithm to find files in google drive api
  function findFileBackOff(parentId, timeoutExponent) {
    var deferred = $q.defer();
    $timeout(() => {
      findFile(parentId).then((response) => {
        deferred.resolve(response);
      }).catch((error) => {
        if(error.status === 403 && timeoutExponent < 5) {
          return findFileBackOff(parentId, timeoutExponent + 1);
        } else {
          deferred.reject(error);
        }
      });
    }, Math.pow(10, timeoutExponent));

    return deferred.promise;
  }

  async function moveProjectFolders(rootFolder, projectFolderId, project_code) {
    cfpLoadingBar.start();

    const currentFolders = await findFolderBackOff(projectFolderId, 1)
      .then(response => response.result.files || [])
      .catch(() => []);
    const projectFolders = structureFor(currentFolders.map(folder => folder.name));

    for (let i = 0; i < projectFolders.length; i++) {
      const folder = projectFolders[i];
      cfpLoadingBar.start();

      const data = {
        name: (i + 1) + '. ' + project_code + '_' + folder,
        parents: [ rootFolder ],
        mimeType: 'application/vnd.google-apps.folder'
      };

      try {
        const parent = await createFolderBackOff(data);
        const parentId = parent.result.id;

        const originalPathFolders = await findFolderBackOff(projectFolderId, 1).then(response => response.result.files);

        for (const originalChildFolder of originalPathFolders) {
          const originalFolderName = originalChildFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          const newFolderName = parent.result.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

          if (originalFolderName.toUpperCase().includes(newFolderName.toUpperCase())) {
            const foundFiles = await findFileBackOff(originalChildFolder.id, 1).then(response => response.result.files);

            for (const childFile of foundFiles) {
              const dataC1 = {
                name: childFile.name,
                parents: [ parentId ]
              };
              try {
                await copyFileBackOff(childFile.id, dataC1, 1);
              } catch (error) {
                toaster.pop('error', 'Creación de Archivo', 'El archivo ' + dataC1.name + ' no se creó en el drive.');
              }
            }
          }
        }
      } catch (error) {
        toaster.pop('error', 'Contenido de Folder', 'No se pudieron recolectar los archivos de la carpeta.');
      } finally {
        cfpLoadingBar.complete();
      }
    }

    if (!$rootScope.isClientUpdate) {
      try {
        await deleteFolder(projectFolderId);
        toaster.pop('success', 'Drive Actualizado', 'Se cambio la ruta del folder del proyecto');
      } catch (error) {
        toaster.pop('error', 'Eliminación del folder antiguo', 'El folder anterior no se eliminó en el drive.');
      } finally {
        toaster.pop('info', 'Google Drive', 'Se ha completado la operación');
      }
    }
  }

  async function moveClientFolders(rootFolder, clientFolderId, clientName) {
    $rootScope.isClientUpdate = true;
    cfpLoadingBar.start();
    for(const folder of NEW_CLIENT_FOLDER_STRUCT_refact) {
      //Se crean carpetas principales (las que estan en NEW_CLIENT_FOLDER_STRUCT_refact)
      const newFolder = {
        name: `${clientName}_${folder.name}`,
        parents: [ rootFolder ],
        mimeType: 'application/vnd.google-apps.folder'
      };
      let parent = await(createFolderBackOff(newFolder));
      const parentId = parent.result.id;

      if(parent.hasOwnProperty('result')) {
        if(folder.hasOwnProperty('childFolders')) {
          for(const childFolder of folder.childFolders) {
            const newChildFolder = {
              name: `${clientName}_${childFolder}`,
              parents: [ parentId ],
              mimeType: 'application/vnd.google-apps.folder'
            };
            const child = await(createFolderBackOff(newChildFolder));
            // Look for folders
            findFolderBackOff(clientFolderId, 1).then((response) => {
              cfpLoadingBar.start();
              const originalPathFolders = response.result.files;
              for(const originalChildFolder of originalPathFolders) {
                const childFolderName = originalChildFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                const newFolderName = parent.result.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                if(childFolderName.toUpperCase().includes(newFolderName.toUpperCase())) {
                  // Look for subfolders inside folder
                  findFolderBackOff(originalChildFolder.id, 1).then((response) => {
                    const originalPathSubFolders = response.result.files;
                    for(const originalSubFolder of originalPathSubFolders) {
                      const childSubFolderName = originalSubFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                      const newSubFolderName   = child.result.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                      if(childSubFolderName.toUpperCase().includes(newSubFolderName.toUpperCase())) {
                        // Look for files inside folder
                        findFileBackOff(originalSubFolder.id, 1).then((response) => {
                          let foundFiles = response.result.files;
                          //Copy all found files
                          for(let childFile of foundFiles) {
                            const dataC1 = {
                              name: childFile.name,
                              parents: [ child.result.id ]
                            };
                            copyFileBackOff(childFile.id, dataC1, 1).then(() => {
                              // TODO: Log that the file was found and copied
                            }).catch(() => {
                              toaster.pop('error', 'Creación de Archivo', 'El archivo ' + dataC1.name + ' no se creo en el drive.');
                            });
                          }
                        }).catch(() => {
                          toaster.pop('error', 'Contenido de Folder', 'No se pudieron recolectar los archivos de la carpeta ' + originalSubFolder.name);
                        });
                      }
                    }
                  }).catch(() => {
                    toaster.pop('error', 'Contenido de Folder', 'No se pudieron recolectar los archivos de la carpeta del Prospecto');
                  });
                }
              }
            }).catch(() => {
              toaster.pop('error', 'Contenido de Folder', 'No se pudieron recolectar los archivos de la carpeta del Prospecto');
            }).finally(() => {
              cfpLoadingBar.complete();
            });
          }
        }
        findFolderBackOff(clientFolderId, 1).then((response) => {
          cfpLoadingBar.start();
          const originalPathFolders = response.result.files;
          for(const originalChildFolder of originalPathFolders) {
            const childFolderName = originalChildFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            const newFolderName   = parent.result.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            if(childFolderName.toUpperCase().includes(newFolderName.toUpperCase())) {
              findFileBackOff(originalChildFolder.id, 1).then((response) => {
                const foundFiles = response.result.files;
                //Copy all found files
                for(const childFile of foundFiles) {
                  const dataC1 = {
                    name: childFile.name,
                    parents: [ parentId ]
                  };
                  copyFileBackOff(childFile.id, dataC1, 1).then(() => {
                    // TODO: Log that the file was found and copied
                  }).catch(() => {
                    toaster.pop('error', 'Creación de Archivo', 'El archivo ' + dataC1.name + ' no se creo en el drive.');
                  });
                }
              }).catch(() => {
                toaster.pop('error', 'Contenido de Folder', 'No se pudieron recolectar los archivos de la carpeta ' + originalChildFolder.name);
              });
            }
          }
        }).catch(() => {
          toaster.pop('error', 'Contenido de Folder', 'No se pudieron recolectar los archivos de la carpeta del Prospecto');
        }).finally(() => {
          cfpLoadingBar.complete();
        });
        if (parent.result.name.includes('Proyectos')) {
          findFolderBackOff(clientFolderId, 1).then((response) => {
            const originalPathFolders = response.result.files;
            for(const originalChildFolder of originalPathFolders) {
              if (originalChildFolder.name.includes('Proyectos')) {
                findFolderBackOff(originalChildFolder.id, 1).then((response) => {
                  const projectPathFolders = response.result.files;
                  for(const projectChildFolder of projectPathFolders) {
                    const dataRoot = {
                      name: projectChildFolder.name,
                      parents: [ parent.result.id ],
                      mimeType: 'application/vnd.google-apps.folder'
                    };
                    //Create Client Root Folder
                    createFolderBackOff(dataRoot).then((response) => {
                      const rootFolder = response.result.id;
                      // Create the folder structure
                      moveProjectFolders(rootFolder, projectChildFolder.id, projectChildFolder.name.substr(0, 11));
                      toaster.pop('warning', 'Favor de esperar a que termine la operacion y se muestre el mensaje de "Se ha completado la operacion"');
                    }).catch((error) => {
                    });
                  }
                }).catch(() => {
                  toaster.pop('error', 'Contenido de Folder', 'No se pudieron recolectar los archivos de la carpeta del proyecto');
                });
              }
            }
          }).catch(() => {
            toaster.pop('error', 'Contenido de Folder', 'No se pudieron recolectar los archivos de la carpeta del proyecto');
          })
        }
      } else {
        toaster.pop('error', `Hubo un error creando carpetas a partir de ${folder.name}`, 'Error en Google');
      }
    }
    deleteFolder(clientFolderId).then(() => {
      toaster.pop('success', 'Drive Actualizado', 'Se cambio la ruta de la carpeta del cliente');
    }).catch(error => {
      toaster.pop('error', 'Eliminacion del folder antiguo', 'El folder anterior no se pudo eliminar del drive.');
    });
    cfpLoadingBar.complete();
    toaster.pop('info', 'Google Drive', 'Se ha completado la operacion');
    $rootScope.isClientUpdate = false;
  }

  async function createNewClientFolders(rootFolder, clientName, isClient) {
    $rootScope.project_folder_id = null;
    $rootScope.project_folder_name = null;

    let foldersToCreate = [];
    if (isClient) {
      foldersToCreate = NEW_CLIENT_FOLDER_STRUCT_refact
    } else {
      foldersToCreate = NEW_PROSPECT_FOLDER_STRUCT_refact
    }
    for(const folder of foldersToCreate) {
      cfpLoadingBar.start();
      //Se crean carpetas principales (las que estan en NEW_CLIENT_FOLDER_STRUCT_refact)
      const newFolder = {
        name: `${clientName}_${folder.name}`,
        parents: [ rootFolder ],
        mimeType: 'application/vnd.google-apps.folder'
      };
      let parent = await(createFolderBackOff(newFolder));
      const parentId = parent.result.id;
      let lastChildId = "";

      if(folder.name === "Proyectos") {
        $rootScope.project_folder_id = parentId;
        $rootScope.project_folder_name = newFolder.name;
      }

      //se empiezan a crear sub carpetas de las carpetas principales
      if(parent.hasOwnProperty('result')) {
        if(folder.hasOwnProperty('childFolders')) {
          for(const childFolder of folder.childFolders) {
            const newChildFolder = {
              name: `${clientName}_${childFolder}`,
              parents: [ parentId ],
              mimeType: 'application/vnd.google-apps.folder'
            };
            const child = await(createFolderBackOff(newChildFolder));
            lastChildId = child.result.id;
          }
        }
      } else {
        toaster.pop('error', `Hubo un error creando carpetas a partir de ${folder.name}`, 'Error en Google');
      }
    }
    cfpLoadingBar.complete();
    toaster.pop('info', 'Google Drive', 'Se ha completado la operacion');
  }

  function findParentFolderBackOff(folderId, timeoutExponent) {
    var deferred = $q.defer();
    $timeout(() => {
      findParentFolder(folderId).then((response) => {
        deferred.resolve(response);
      }).catch((error) => {
        if(error.status === 403 && timeoutExponent < 5) {
          return findParentFolderBackOff(parentId, timeoutExponent + 1);
        } else {
          return deferred.reject(error);
        }
      });
    }, Math.pow(10, timeoutExponent));

    return deferred.promise;
  }

  function findParentFolderName(parentId) {
    return $window.gapi.client.request({
      'path': `https://www.googleapis.com/drive/v3/files/${parentId}?fields=name`,
      'method': 'GET',
      'headers': {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      }
    });
  }

  function findFolderByName(folderName, parentFolder) {
    //poner el id de la carpeta principal de clientes donde estan las 5 carpetas principales de los clientes
    return $window.gapi.client.request({
      'path': `https://content.googleapis.com/drive/v3/files?q=fullText+contains+%27${folderName}%27+and+mimeType%3D%27application%2Fvnd.google-apps.folder%27+and+%27${parentFolder}%27+in+parents`,
      'method': 'GET',
      'headers': {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + $window.localStorage.googleToken,
      }
    });
  }

  // Funcion para encontrar las carpetas del cliente y del prospecto para su conversion
  async function compareClientAndProspectFolders(searchIn, prospectFolderId, searchFolderName, clientFolderId) {
    await findFolderByName(searchIn, prospectFolderId).then(async (response) => {
      cfpLoadingBar.start();
      if (response?.result?.files?.length > 0)
      {
        const prospectAdministrationFolderId = response.result.files[0].id;
        await findFolderByName(searchFolderName, prospectAdministrationFolderId).then(async (response) => {
          if (response?.result?.files?.length > 0)
          {
            const prospectGeneralProspectDataFolderId = response.result.files[0].id;
            await findFileBackOff(prospectGeneralProspectDataFolderId, 1).then(async(response) => {
                const foundFiles = response.result.files;
                //Copy all found files
                for(const childFile of foundFiles) {
                  const dataC1 = {
                    name: childFile.name,
                    parents: [ clientFolderId ]
                  };
                  await copyFileBackOff(childFile.id, dataC1, 1).then(() => {
                    console.log('File found and copied:', dataC1.name);
                  }).catch(() => {
                    toaster.pop('error', 'Creación de Archivo', 'El archivo ' + dataC1.name + ' no se creo en el drive.');
                  });
                }
              }).catch(() => {
                toaster.pop('error', 'Contenido de Folder', 'No se pudieron recolectar los archivos de la carpeta ' + subFolder.name);
              });
          }
        });
      }
      cfpLoadingBar.complete();
    });
  }

  return {
    initClient() {
      $window.gapi.load('picker');
      $window.gapi.load('client');
      client = google.accounts.oauth2.initCodeClient({
        immediate: false,
        client_id: CLIENT_ID,
        scope: USER_SCOPE,
        response_type: 'code',
        cookie_policy: 'single_host_origin',
        prompt: 'consent',
        callback: (tokenResponse) => {
          access_token = tokenResponse.code;
          jQuery.ajax({type: 'POST', url: BASE_AUTH_URL, data: tokenResponse,
            complete: function(responseData) {
              if(responseData.status === 200) {
                $rootScope.isAuthenticated = true;
                $auth.setToken(responseData.responseJSON.meta.token);
                const firebaseToken = responseData.responseJSON.meta.firebase_token;

                if (firebaseToken) {
                  $rootScope.firebase.auth().signInWithCustomToken(firebaseToken)
                    .then(function(firebaseUser) {
                      $state.go('app.projects.list');
                      $rootScope.$broadcast('user:login', responseData.responseJSON.user);
                    })
                    .catch(function(error) {
                      console.error("ERROR DE FIREBASE:", error);
                      toaster.pop('error', 'Error de Firebase', 'No se pudo iniciar la sesión con los servicios en tiempo real.');
                    });
                } else {
                  $state.go('app.projects.list');
                }
                $window.localStorage.googleToken = responseData.responseJSON.meta.google_token;
                $window.localStorage.apiUser = JSON.stringify(responseData.responseJSON.user);
                $window.localStorage.currentUser = JSON.stringify(responseData.responseJSON.credentials);

                var fecha = new Date();
                fecha.setFullYear(fecha.getFullYear() + 1);
                const ApiUser = localStorage.getItem('apiUser');
                const token = localStorage.getItem('thoth_token');
                const googleToken = localStorage.getItem('googleToken');

                document.cookie = "apiUser=" + ApiUser + "; expires=" + fecha.toUTCString() + "; domain=" + DOMAIN;
                document.cookie = "thoth_token=" + token + "; expires=" + fecha.toUTCString() + "; domain=" + DOMAIN;
                document.cookie = "googleToken=" + googleToken + "; expires=" + fecha.toUTCString() + "; domain=" + DOMAIN;

                return $state.go('app.projects.list');
              }
              if(responseData.status === 302) {
                console.log(responseData);
              }
              if(responseData.status === 422) {
                return toaster.pop('error', 'Error', responseData.responseJSON.errors);
              }
            },
            error: function(error) {
              console.log(error);
            }
          });
        },
      });
    },
    login() {
      client.requestCode();
    },
    logout() {
      google.accounts.oauth2.revoke(access_token, () => {
        $rootScope.isAuthenticated = false;
        delete $window.localStorage.googleToken;
        console.log('Logout correctly, access token revoked')
        $rootScope.firebase
          .auth()
          .signOut()
          .then(() => {
            console.log("logout from firebase successful");
          })
          .catch(error => {
            console.error(error);
          });
        var now = new Date();
        now.setSeconds(now.getSeconds() - 1);
        document.cookie = 'apiUser' +  "=; expires=" + now.toUTCString() + "; path=/; domain=" + DOMAIN;
        document.cookie = 'thoth_token' +  "=; expires=" + now.toUTCString() + "; path=/; domain=" + DOMAIN;
        return $state.go('sign_in');
      });
    },
    pickerApiLoad: function(parentId, type) {
      pickerApiLoaded = true;
      switch (type) {
        case 'folder':
          createFolderPicker(parentId);
          break;
        case 'form':
          createFormPicker(parentId);
          break;
        case 'file':
          createFilePicker(parentId);
          break;
      }
    },
    createProspectFolderStructure: ((prospectName) => {
      cfpLoadingBar.start();
      let deferred = $q.defer();
      let rootId;
      let data = {
        name: "CV_" + prospectName,
        parents: [ $rootScope.rootPath.id ],
        mimeType: 'application/vnd.google-apps.folder'
      };
      createFolder(data).then((response) => {
        toaster.pop('success', 'Drive Actualizado', 'La carpeta ' + response.result.name + ' se creo en el drive', 5000);
        rootId = response.result.id;
        data = {
          name: "CV_" + prospectName + " Administración",
          parents: [ rootId ],
          mimeType: 'application/vnd.google-apps.folder'
        };
        createFolder(data).then((response) => {
          toaster.pop('success', 'Drive Actualizado', 'La carpeta ' + response.result.name + ' se creo en el drive', 5000);
          data = {
            name: "CV_" + prospectName + " Documentos de Identificación del Cliente",
            parents: [ response.result.id ],
            mimeType: 'application/vnd.google-apps.folder'
          };
          createFolder(data).then(() => {
            toaster.pop('success', 'Drive Actualizado', 'La carpeta ' + response.result.name + ' se creo en el drive', 5000);
          }).catch((error) => {
            deferred.reject(error);
          }).finally(() => {
            cfpLoadingBar.complete();
          });
        }).catch((error) => {
          deferred.reject(error);
          cfpLoadingBar.complete();
        });
        deferred.resolve(response.result);
      }).catch((error) => {
        cfpLoadingBar.complete();
        deferred.reject(error);
      });
      return deferred.promise;
    }),
    // Busca dentro de la carpeta del proyecto la subcarpeta cuyo nombre contenga
    // el fragmento dado. Se busca por fragmento porque el nombre lleva el codigo
    // del proyecto delante ("1. 03280_Requerimientos").
    findFolderByName: function(parentFolderId, nameFragment) {
      var deferred = $q.defer();
      this.retrieveFilesInFolder(parentFolderId).then(function(response) {
        var folder = (response.result.files || []).find(function(file) {
          return file.mimeType === 'application/vnd.google-apps.folder' &&
            file.name.toLowerCase().indexOf(nameFragment.toLowerCase()) !== -1;
        });
        deferred.resolve(folder);
      }).catch(function(error) {
        deferred.reject(error);
      });
      return deferred.promise;
    },
    // Sube un archivo del equipo a una carpeta de Drive. Se arma la peticion
    // multipart a mano porque gapi.client no expone la subida de contenido.
    uploadFileToFolder: function(file, folderId) {
      var deferred = $q.defer();
      var boundary = 'sia_boundary_' + Date.now();
      var metadata = { name: file.name, parents: [folderId] };

      var reader = new FileReader();
      reader.onload = function() {
        var body =
          '--' + boundary + '\r\n' +
          'Content-Type: application/json; charset=UTF-8\r\n\r\n' +
          JSON.stringify(metadata) + '\r\n' +
          '--' + boundary + '\r\n' +
          'Content-Type: ' + (file.type || 'application/octet-stream') + '\r\n' +
          'Content-Transfer-Encoding: base64\r\n\r\n' +
          btoa(reader.result) + '\r\n' +
          '--' + boundary + '--';

        $window.gapi.client.request({
          path: 'https://www.googleapis.com/upload/drive/v3/files',
          method: 'POST',
          params: { uploadType: 'multipart', fields: 'id,name,webViewLink' },
          headers: {
            'Content-Type': 'multipart/related; boundary=' + boundary,
            'Authorization': 'Bearer ' + $window.localStorage.googleToken
          },
          body: body
        }).then(function(response) {
          deferred.resolve(response.result);
        }, function(error) {
          deferred.reject(error);
        });
      };
      reader.onerror = function() { deferred.reject(reader.error); };
      reader.readAsBinaryString(file);

      return deferred.promise;
    },
    retrieveFilesInFolder: function(folderId) {
      return $window.gapi.client.request({
        'path': 'https://www.googleapis.com/drive/v3/files/',
        'method': 'GET',
        'headers': {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + $window.localStorage.googleToken,
        },
        'params': {
          'orderBy': 'folder',
          'pageSize':  200,
          'q': 'parents in \"' + folderId + '\" and trashed = false',
        }
      });
    },
    moveFile: function(fileId, oldFolderId, newFolderId) {
      return $window.gapi.client.request({
        path: `https://www.googleapis.com/drive/v3/files/${fileId}`,
        method: 'PATCH',
        params: {
          addParents: newFolderId,
          removeParents: oldFolderId,
          fields: 'id, parents'
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + $window.localStorage.googleToken
        },
        body: {}
      });
    },
    getClientBaseFolderId: function() {
      return BASE_CLIENT_PATH_KEY;
    },
    getFolderName: function(folderId) {
      return $window.gapi.client.request({
        path: 'https://www.googleapis.com/drive/v3/files/' + folderId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + $window.localStorage.googleToken
        }
      });
    },
    findFolder: function(folderId) {
      return $window.gapi.client.request({
        path: 'https://www.googleapis.com/drive/v3/files/',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + $window.localStorage.googleToken,
        },
        params: {
          'orderBy': 'name',
          'q': 'parents in \"' + folderId + '\" and mimeType = \"' + 'application/vnd.google-apps.folder' + '\" and trashed = false',
        }
      });
    },
    createMissingFolder: function(folderId, projectCode, folderChecklist, structure) {
      cfpLoadingBar.start();
      const projectFolders = structure || folders;
      const folderPromises = [];
      for (let i = 0; i < projectFolders.length; i++) {
        if (!folderChecklist[i]) {
          const projectCodeBit = projectCode;
          const data = {
            name: (i + 1) + '. ' + projectCodeBit + '_' + projectFolders[i],
            parents: [folderId],
            mimeType: 'application/vnd.google-apps.folder'
          };

          const promise = createFolder(data).then((response) => {
            toaster.pop('success', 'Drive Actualizado', 'La carpeta: ' + response.result.name + ' se creó en el Drive.');
          });
          folderPromises.push(promise);
        }
      }

      return Promise.all(folderPromises).finally(() => {
        cfpLoadingBar.complete();
      });
    },
    updateFolderName: function(folderId, folderName) {
      var data = {
        name: folderName,
        mimeType: 'application/vnd.google-apps.folder'
      };
      return $window.gapi.client.request({
        'path': 'https://www.googleapis.com/drive/v3/files/' + folderId,
        'method': 'PATCH',
        'headers': {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + $window.localStorage.googleToken,
        },
        'body': data
      });
    },
    deleteFolder: function(folderId) {
      return $window.gapi.client.request({
        'method': 'DELETE',
        'path': `https://www.googleapis.com/drive/v3/files/${folderId}?supportsAllDrives=true`,
        'headers': {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + $window.localStorage.googleToken,
        }
      }).then(function(response) {
        return response;
      }).catch(function(error) {
        throw error;
      });
    },
    copyAllFiles: function(sourceFolderId, targetFolderId) {
      const token = $window.localStorage.googleToken;
      return $window.gapi.client.request({
        'method': 'GET',
        'path': 'https://www.googleapis.com/drive/v3/files',
        'params': {
          q: `'${sourceFolderId}' in parents and trashed = false`,
          fields: 'files(id, name)',
          supportsAllDrives: true
        },
        'headers': {
          'Authorization': 'Bearer ' + token
        }
      }).then(function(response) {
        const files = response.result.files || [];

        const copyRequests = files.map(file => {
          return $window.gapi.client.request({
            'method': 'POST',
            'path': `https://www.googleapis.com/drive/v3/files/${file.id}/copy?supportsAllDrives=true`,
            'headers': {
              'Authorization': 'Bearer ' + token,
              'Content-Type': 'application/json'
            },
            'body': {
              name: file.name,
              parents: [targetFolderId]
            }
          });
        });

        return Promise.all(copyRequests);
      }).then(function(results) {
        return results;
      }).catch(function(error) {
        throw error;
      });
    },
    folderStructureFor: structureFor,
    templateDocumentName: templateDocumentName,
    projectTemplates: function() {
      return PROJECT_TEMPLATES.map(function(template) {
        return { document: template.document, folder: template.folder, fileId: configValue(template.readId) };
      });
    },
    copyProjectTemplates: function(project_code, name, folderIds) {
      const pending = [];
      const copies = this.projectTemplates().map((template) => {
        const folderId = (folderIds || {})[template.folder];
        if (!template.fileId || !folderId) {
          pending.push(template.document);
          return $q.when();
        }

        return $q.when(this.getFolderName(template.fileId)).then((response) => {
          return copyFileBackOff(template.fileId, {
            name: templateDocumentName(response.result.name, project_code, name),
            parents: [ folderId ]
          }, 1);
        }).catch(() => {
          pending.push(template.document);
        });
      });

      return $q.all(copies).then(() => {
        if (pending.length) {
          toaster.pop('warning', 'Documentos del proyecto', 'No se generaron: ' + pending.join(', ') + '. Hay que agregarlos a mano.');
        } else {
          toaster.pop('success', 'Documentos del proyecto', 'Se generaron los documentos base en sus carpetas');
        }
        return pending;
      });
    },
    projectFolderNames: function(project_code, structure) {
      return (structure || folders).map(function(folder, index) {
        return (index + 1) + '. ' + project_code + '_' + folder;
      });
    },
    recreateFolderStructure: function(drive_id, project_code) {
      var deferred = $q.defer();
      var service = this;
      cfpLoadingBar.start();
      // Retrieve all Folders from Drive.
      this.findFolder(drive_id).then(function(response) {
        var foldersFound = response.result.files || [];
        var structure = service.folderStructureFor(foldersFound.map(function(file) { return file.name; }));
        var expected = service.projectFolderNames(project_code, structure);
        // Check that the structure in drive is correct (compares the found folders to the expected list of folders).
        var folderChecklist = expected.map(function(name) {
          return foldersFound.some(function(file) { return file.name === name; });
        });
        cfpLoadingBar.complete();
        deferred.resolve({ folders: structure, checklist: folderChecklist });
      }, function(error) {
        cfpLoadingBar.complete();
        deferred.reject(error);
      });
      return deferred.promise;
    },
    createCalendarEvent: function(data) {
      var deferred = $q.defer();
      cfpLoadingBar.start();
      createEvent(data).then((response) => {
        toaster.pop('success', 'Creación del Evento', 'El evento fue creado exitosmanete');
        cfpLoadingBar.complete();
        deferred.resolve(response);
      }, function(error) {
        cfpLoadingBar.complete();
        deferred.reject(error);
      });
      return deferred.promise;
    },
    renameChildFolders: function(oldName, newName, folderId){
      var deferred = $q.defer();
      cfpLoadingBar.start();
      // Retrieve all Folders from Drive.
      this.findFolder(folderId).then((response) => {
        var foundFolders = response.result.files;
        for(var i = 0; i < foundFolders.length; i++) {
          if(foundFolders[i].name.includes(oldName)) {
            var updatedName = newName + foundFolders[i].name.substr(oldName.length, foundFolders[i].name.length);
            updateFolderName(foundFolders[i].id, updatedName).then(() => {
              //Success
              toaster.pop('success', 'Drive Actualizado', 'La carpeta ' + foundFolders[i].name + ' se creo en el drive', 5000, 'trustedHtml', function() {
                $timeout(function() {
                  window.open("https://drive.google.com/drive/folders/" + folderId);
                }, 0);
              });
            }).catch((error) => {
              cfpLoadingBar.complete();
              deferred.reject(error);
            });
          }
        }

      }).catch((error) => {
        cfpLoadingBar.complete();
        deferred.reject(error);
      }).finally(() => {
        cfpLoadingBar.complete();
        deferred.resolve();
      });

      return deferred.promise;
    },
    renameChildClientFolders: function(newName, folderId, oldName){
      var deferred = $q.defer();
      cfpLoadingBar.start();
      // Retrieve all Folders from Drive.
      this.findFolder(folderId).then((response) => {
        var foundFolders = response.result.files;
        for(const folder of foundFolders) {
          if(folder.name.includes(oldName)) {
            var updatedName = newName + folder.name.substr(oldName.length, folder.name.length);
            updateFolderName(folder.id, updatedName).then(() => {
              //Success
            }).catch((error) => {
              cfpLoadingBar.complete();
              deferred.reject(error);
            });
            if (folder.name.substr(oldName.length+1, folder.name.length) === 'Administración' || folder.name.substr(oldName.length+1, folder.name.length) === 'Comercial') {
              this.findFolder(folder.id).then(async (response) => {
                var foundSubChildFolders = response.result.files;
                for(const subFolder of foundSubChildFolders) {
                  if(subFolder.name.includes(oldName)) {
                    var updatedName = newName + subFolder.name.substr(oldName.length, subFolder.name.length);
                    await updateFolderName(subFolder.id, updatedName).then(() => {
                      //Success
                    }).catch((error) => {
                      cfpLoadingBar.complete();
                      deferred.reject(error);
                    });;
                  }
                }
              }).catch((error) => {
                cfpLoadingBar.complete();
                deferred.reject(error);
              });
            }
          }
        }

        deferred.resolve();
      }).catch((error) => {
        cfpLoadingBar.complete();
        deferred.reject(error);
      });
      cfpLoadingBar.complete();
      toaster.pop('success', 'Drive Actualizado', 'Se actualizo el nombre de las carpetas del cliente ');
      return deferred.promise;
    },
    createQuotationsFolder: function(prospectName, folderId) {
      var deferred = $q.defer();
      var data = {
        name: "CV_" + prospectName + " Cotización",
        parents: [ folderId ],
        mimeType: 'application/vnd.google-apps.folder'
      };
      cfpLoadingBar.start();
      createFolder(data).then(function(response) {
        const root_id = response.result.id;
        toaster.pop('success', 'Drive Actualizado', 'La carpeta ' + response.result.name + ' se creo en el drive', 5000, 'trustedHtml', function() {
          $timeout(function() {
            window.open("https://drive.google.com/drive/folders/" + root_id);
          }, 0);
        });

        // Copy file templates
        for(const folder of NEW_QUOTATION_FOLDER_STRUCT) {
          const data = {
            name: `${prospectName}${folder.name}`,
            parents: [ root_id ]
          };
          copyFileBackOff(folder.pathKey, data, 1).then((response) => {
            toaster.pop('success', 'Drive Actualizado', 'El archivo ' + response.result.name + ' se creo en el drive', 5000, 'trustedHtml', function() {
              $timeout(function() {
                window.open("https://drive.google.com/drive/folders/" + root_id);
              }, 0);
            });
          }).catch((error) => {
            toaster.pop('error', 'Creación de Archivo', 'El archivo' + data.name + ' no se creo en el drive.');
            deferred.reject(error);
          });
        }

        deferred.resolve(data);
      }, function(error) {
        toaster.pop('error', 'Creación de Carpeta', 'La carpeta no se creo en el drive.');
        deferred.reject(error);
      });

      cfpLoadingBar.complete();
      return deferred.promise;
    },
    //Funcion que sirve para mover las carpetas del proyecto
    moveProjectFolderStructure: function(drive_id, root_id, folderName, project_code) {
      $rootScope.isClientUpdate = false;
      cfpLoadingBar.start();
      const deferred = $q.defer();
      const dataRoot = {
        name: folderName,
        parents: [ root_id ],
        mimeType: 'application/vnd.google-apps.folder'
      };
      //Create Client Root Folder
      createFolderBackOff(dataRoot).then((response) => {
        const rootFolder = response.result.id;
        // Create the folder structure
        toaster.pop('warning', 'Favor de esperar a que termine la operacion y se muestre el mensaje de "Se ha completado la operacion"');
        moveProjectFolders(rootFolder, drive_id, project_code).then(() => {
          const data = {
            project_root_id: response.result.id,
            project_root_url: `${GOOGLE_BASE_FOLDER_URL}${response.result.id}`
          };
          deferred.resolve(data);
        }).catch((error) => {
          deferred.reject(error);
        }).finally(() => {
          cfpLoadingBar.complete();
        });
      }).catch((error) => {
        deferred.reject(error);
        cfpLoadingBar.complete();
      });

      return deferred.promise;
    },

    //Funcion que sirve para crear las carpetas del proyecto
    // parentId es opcional: quien no lo mande sigue usando rootPath, que es lo
    // que fija la pantalla de nuevo proyecto al elegir cliente.
    createProjectFolderStructure: function(folderName, project_code, parentId) {
      var parent = parentId || ($rootScope.rootPath && $rootScope.rootPath.id);
      if (!parent) {
        return $q.reject('No se sabe en que carpeta de Drive crear el proyecto.');
      }

      $rootScope.isClientUpdate = false;
      cfpLoadingBar.start();
      var deferred = $q.defer();
      var rootId;
      var data = {
        name: folderName,
        parents: [ parent ],
        mimeType: 'application/vnd.google-apps.folder'
      };
      var service = this;
      createFolderBackOff(data, 1).then((response) => {
        cfpLoadingBar.start();
        // toaster.pop('warning', 'Favor de esperar a que termine la operacion y se muestre el mensaje de "Se ha completado la operacion"');
        rootId = response.result.id;
        cfpLoadingBar.complete();
        const folderIds = {};
        const creations = folders.map(function(folder, index) {
          cfpLoadingBar.start();
          //create folders inside proyect folder
          return createFolderBackOff({
            name: (index + 1) + '. ' + project_code + '_' + folder,
            parents: [ rootId ],
            mimeType: 'application/vnd.google-apps.folder'
          }, 1).then((created) => {
            folderIds[folder] = created.result.id;
            cfpLoadingBar.complete();
          });
        });
        const createdFolder = {
          id: response.result.id,
          url: `${GOOGLE_BASE_FOLDER_URL}${response.result.id}`
        };
        $q.all(creations).then(() => {
          return service.copyProjectTemplates(project_code, projectNameFrom(folderName, project_code), folderIds);
        }).catch(() => {
          // La creacion del proyecto no depende de las plantillas.
        }).finally(() => {
          deferred.resolve(createdFolder);
          cfpLoadingBar.complete();
          toaster.pop('success', 'Google Drive', 'Se ha creado correctamente la estructura del proyecto');
          toaster.pop('info', 'Google Drive', 'Se ha completado la operacion');
        });
      }).catch((error) => {
        deferred.reject(error);
      });
      return deferred.promise;
    },
    //Funcion que sirve para mover las carpetas del cliente
    moveClientFolderStructure: function(clientName, clientFolderId, rootFolderId) {
      $rootScope.isClientUpdate = true;
      cfpLoadingBar.start();
      const deferred = $q.defer();
      const dataRoot = {
        name: clientName,
        parents: [ rootFolderId ],
        mimeType: 'application/vnd.google-apps.folder'
      };
      //Create Client Root Folder
      createFolderBackOff(dataRoot).then((response) => {
        // const rootFolder = response.result.id;
        // // Create the folder structure
        // moveClientFolders(rootFolder, clientFolderId, clientName);
        // toaster.pop('warning', 'Favor de esperar a que termine la operacion y se muestre el mensaje de "Se ha completado la operacion"');
        toaster.pop('warning', 'Se han hecho modificaciones en el drive del cliente. Por favor haga las modificaciones manualmente');
        const data = {
          client_root_id: response.result.id,
          client_root_url: `${GOOGLE_BASE_FOLDER_URL}${response.result.id}`
        };
        deferred.resolve(data);
      }).catch((error) => {
        deferred.reject(error);
      }).finally(() => {
        cfpLoadingBar.complete();
      });
      cfpLoadingBar.complete();
      return deferred.promise;
    },
    //Funcion que sirve para crear las carpetas del cliente
    createClientFolderStructure:async function(clientName, parentFolderId, isClient) {
      const deferred = $q.defer();
      const dataRoot = {
        name: clientName,
        parents: [ parentFolderId ],
        mimeType: 'application/vnd.google-apps.folder'
      };
      //Create Client Root Folder
      await createFolderBackOff(dataRoot).then(async (response) => {
        toaster.pop('warning', 'Favor de esperar a que termine la operacion y se muestre el mensaje de "Se ha completado la operacion"');
        const rootFolder = response.result.id;
        // Create the folder structure
        await createNewClientFolders(rootFolder, clientName, isClient);
        const data = {
          client_root_id: response.result.id,
          client_root_url: `${GOOGLE_BASE_FOLDER_URL}${response.result.id}`,
          project_drive_id: $rootScope.project_folder_id,
          project_drive_folder_name: $rootScope.project_folder_name
        };
        deferred.resolve(data);
      }).catch((error) => {
        deferred.reject(error);
      }).finally(() => {
        $rootScope.project_folder_id = null;
        $rootScope.project_folder_name = null;
        cfpLoadingBar.complete();
      });

      return deferred.promise;
    },
    createQuotationProspectFolder: function(prospectFolderId) {
      const deferred = $q.defer();
      cfpLoadingBar.start();
      //Find Quotations Folder
      findFolderBackOff(prospectFolderId, 1).then((response) => {
        const foundFolders = response.result.files;
        for(const childFolder of foundFolders) {
          const childFolderName = childFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          if(childFolderName.toUpperCase().includes("ADMINISTRACION")) {
            const data = {
              name: 'CONTRATO_PLD_2019',
              parents: [ childFolder.id ]
            };
            copyFileBackOff(PRODUCT_CONTRACT_PATH_KEY, data, 1).catch(() => {
              toaster.pop('error', 'Copiar Archivos', 'No se pudo copiar el archivo del contrato de PLD');
            });
          }

        }

      });

      cfpLoadingBar.complete();
      return deferred.promise;
    },
    findChildFolder: function(folderId, projectName) {
      const deferred = $q.defer();
      findFolderBackOff(folderId, 1).then((response) => {
        const foundFolders = response.result.files;
        for(let childFolder of foundFolders) {
          const childFolderName = childFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          if(childFolderName.toUpperCase().includes("PROYECTOS")) {
            findFolderBackOff(childFolder.id, 1).then((response) => {
              for(let proyectFolder of response.result.files) {
                const projectFolderName = proyectFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                console.log(projectFolderName)
                console.log(projectName)
                if(projectFolderName.toUpperCase().includes(projectName.toUpperCase())) {
                  deferred.resolve({
                    id: proyectFolder.id,
                    url: `${GOOGLE_BASE_FOLDER_URL}${proyectFolder.id}`
                  });
                }
              }
              deferred.reject("Folder not found");
            }).catch((error) => {
              deferred.reject(error);
            });
          }
        }
      }).catch((error) => {
        deferred.reject(error);
      });

      return deferred.promise;
    },
    selectClientProjectFolder: function(folderId) {
      const deferred = $q.defer();
      findFolderBackOff(folderId, 1).then((response) => {
        const foundFolders = response.result.files;
        for(let childFolder of foundFolders) {
          const childFolderName = childFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          if(childFolderName.toUpperCase().includes("PROYECTOS")) {
            deferred.resolve(childFolder.id);
          }
        }
      }).catch((error) => {
        deferred.reject(error);
      });
      return deferred.promise;
    },
    moveProspectFoldersToClientFolders:async function(folderId, prospectName, newFolderId) {
      const deferred = $q.defer();

      // Find client folder
      this.findFolder(newFolderId).then((response) => {
        toaster.pop('warning', 'Copiando archivos', 'Se estan copiando los archivos porfavor espere a que termine el proceso');
        this.createClientFolderStructure(prospectName, newFolderId, true).then(async (response) => {
          $rootScope.clientFolderInfo = response
          const clientId = response.client_root_id
          await this.findFolder(clientId).then(async(response) => {
            const foundFolders = response.result.files;
            for(const childFolder of foundFolders) {
              const childFolderName = childFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
              if(childFolderName.toUpperCase().includes("ADMINISTRACION") || childFolderName.toUpperCase().includes("COMERCIAL")) {
                await this.findFolder(childFolder.id).then(async (response) => {
                  var foundSubChildFolders = response.result.files;
                  for(const subFolder of foundSubChildFolders) {
                    //check for folder to copy content of prospect folders
                    const newClientFolderName = subFolder.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    if (newClientFolderName.includes('Documentos de Identificacion del Cliente')) {
                      await compareClientAndProspectFolders('Administración', folderId, 'Datos generales del prospecto', subFolder.id)
                    } else if (newClientFolderName.includes('Contratos')) {
                      await compareClientAndProspectFolders('Administración', folderId, 'NDA', subFolder.id)
                      await compareClientAndProspectFolders('Comercial', folderId, 'Borradores de contrato', subFolder.id)
                    } else if (newClientFolderName.includes('Propuesta de servicio')) {
                      await compareClientAndProspectFolders('Comercial', folderId, 'Propuesta de servicio', subFolder.id)
                    } else if (newClientFolderName.includes('Informacion del negocio del cliente')) {
                      await compareClientAndProspectFolders('Comercial', folderId, 'Informacion del negocio del cliente', subFolder.id)
                    }
                  }
                })
              }
            }
            deferred.resolve($rootScope.clientFolderInfo)
          });
        }).catch((error) => {
          deferred.reject(error);
        }).finally(() => {
          toaster.pop('success', 'Archivos copiados', 'Se copiaron los archivos correctamente');
        });
      }).catch((error) => {
        deferred.reject(error);
      });

      return deferred.promise;
    },
    deleteFolders: function(folderId) {
      deleteFolder(folderId).then(() => {
        toaster.pop('success', 'Drive Actualizado', 'Se elimino correctamente el folder anterior');
      }).catch(() => {
        toaster.pop('error', 'Eliminacion del folder antiguo', 'El folder anterior no se pudo eliminar del drive.');
      });
    },
  };

}]);
